(function () {
  if (window.__slLoaded) return;
  window.__slLoaded = true;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdowns(root) {
    var nodes = root.querySelectorAll('[data-sl-countdown]');
    if (!nodes.length) return;
    var timers = [];
    Array.prototype.forEach.call(nodes, function (node) {
      var end = Date.parse(node.getAttribute('data-sl-countdown'));
      var days = parseInt(node.getAttribute('data-sl-countdown-days'), 10);
      if (isNaN(end) && days > 0) {
        var d = new Date();
        d.setDate(d.getDate() + days);
        d.setHours(23, 59, 59, 0);
        end = d.getTime();
      }
      if (isNaN(end)) return;
      timers.push({
        node: node,
        end: end,
        hrs: node.querySelector('[data-sl-hrs]'),
        min: node.querySelector('[data-sl-min]'),
        sec: node.querySelector('[data-sl-sec]'),
        days: node.querySelector('[data-sl-days]'),
        daysWrap: node.querySelectorAll('[data-sl-days-wrap]')
      });
    });

    function tick() {
      var now = Date.now();
      var active = 0;
      timers.forEach(function (t) {
        var left = Math.floor((t.end - now) / 1000);
        var wrap = t.node.closest('.sl-offer__deadline');
        if (left <= 0) {
          t.node.hidden = true;
          if (wrap) wrap.hidden = true;
          return;
        }
        active++;
        var days = Math.floor(left / 86400);
        var showDays = days > 0 && !!t.days;
        if (t.days) t.days.textContent = pad(days);
        Array.prototype.forEach.call(t.daysWrap, function (el) {
          el.hidden = !showDays;
        });
        t.hrs.textContent = pad(Math.floor((showDays ? left % 86400 : left) / 3600));
        t.min.textContent = pad(Math.floor((left % 3600) / 60));
        t.sec.textContent = pad(left % 60);
        t.node.hidden = false;
        if (wrap) wrap.hidden = false;
      });
      if (active) window.setTimeout(tick, 1000);
    }

    tick();
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-sl-sticky]');
    if (!bar) return;
    var offer = root.querySelector('[data-sl-offer]');
    var link = bar.querySelector('a');
    var queued = false;

    function sync() {
      queued = false;
      var vh = window.innerHeight;
      var scrollable = document.documentElement.scrollHeight - vh;
      var pastHalf = scrollable > 0 && window.scrollY / scrollable >= 0.5;
      var beforeOffer = offer ? offer.getBoundingClientRect().top > vh : true;
      var show = pastHalf && beforeOffer;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    sync();
  }

  function bindTracking(root) {
    var pageHandle = root.getAttribute('data-sl-page') || window.location.pathname;
    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var cta = target.closest('[data-sl-cta]');
      if (!cta) return;
      try {
        if (typeof gtag === 'function') {
          gtag('event', 'listicle_cta_click', {
            cta_position: cta.getAttribute('data-sl-cta'),
            page_handle: pageHandle
          });
        }
      } catch (err) {}
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sl'), function (root) {
      if (root.hasAttribute('data-sl-ready')) return;
      root.setAttribute('data-sl-ready', '');
      initCountdowns(root);
      initSticky(root);
      bindTracking(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
